<template>
  <v-content class="bg-content">
    <v-container grid-list-xl style="padding: 10px; top: -0px">
      <div v-if="showImageOverlay" class="overlay">
      <img src="@/assets/images/loading-spinner15.gif" alt="Cogneetiv AI" class="animated-image">
    </div>
      <v-card dark class="card-animate-2">
          <v-app-bar
            color="rgba(12, 22, 27, 0.9)"
            max-height="75"
            height="75"
            elevation="3"
            dense
            dark
          >
            <v-toolbar-title>
              <v-avatar size="40">
                                <img src="@/assets/DesignIcon.png">
                        </v-avatar>
              Generative AI
            </v-toolbar-title>

            <v-spacer></v-spacer>
   
          </v-app-bar>
        </v-card>
      <v-card class="book-generator card-animate-2">
        <v-card-text>
          <v-form ref="form">
            <v-container grid-list-xl>
    <v-layout row wrap>
      <v-flex xs12 sm12 md6 lg3 xl3 class="v-stepper">
        <v-stepper v-model="currentStep" style="background-color: rgba(12, 22, 27, 0.9);">
          <v-stepper-step :complete="currentStep > 1" step="1"><p class="steppertitle">Concept</p></v-stepper-step>
        </v-stepper>
      </v-flex>

      <v-flex xs12 sm12 md6 lg3 xl3 class="v-stepper">
        <v-stepper v-model="currentStep" style="background-color: rgba(12, 22, 27, 0.9);">
          <v-stepper-step :complete="currentStep > 2" step="2"><p class="steppertitle">Table of Contents</p></v-stepper-step>
        </v-stepper>
      </v-flex>

      <v-flex xs12 sm12 md6 lg3 xl3 class="v-stepper">
        <v-stepper v-model="currentStep" style="background-color: rgba(12, 22, 27, 0.9);">
          <v-stepper-step :complete="currentStep > 3" step="3"><p class="steppertitle">Chapters</p></v-stepper-step>
        </v-stepper>
      </v-flex>

      <v-flex xs12 sm12 md6 lg3 xl3 class="v-stepper">
        <v-stepper v-model="currentStep" style="background-color: rgba(12, 22, 27, 0.9);">
          <v-stepper-step :complete="currentStep > 4" step="4"><p class="steppertitle">Images</p></v-stepper-step>
        </v-stepper>
      </v-flex>
    </v-layout>
  </v-container>
  <v-container grid-list-xl style="padding: 15px; margin-top: 0px">
  <v-layout row wrap>
      <v-flex x124 sm12 md6 lg4 xl4>
  <v-text-field v-model="bookLength" autocomplete="on" type="text" autofocus label="Book Length" required class="inputarea custom-text-field"></v-text-field>
  </v-flex>
  <v-flex xs12 sm12 md4 lg6 xl4>
    <v-text-field v-model="gptRole" label="Role" required class="inputarea custom-text-field"></v-text-field>
    </v-flex>
    <v-flex xs12 sm12 md6 lg4 xl4>
    <v-text-field v-model="genre" label="Genre" required class="inputarea custom-text-field"></v-text-field>
  </v-flex>
  <v-flex xs12 sm12 md6 lg12 xl12>
  <v-text-field v-model="keywords" label="Keywords" hint="Use commas to separate keywords" required class="inputarea custom-text-field"></v-text-field>
  </v-flex>
  <v-flex xs12 sm12 md6 lg12 xl12>
    <v-select v-model="selectedImageTypes" :items="imageOptions" label="Select image types to generate" multiple attach chips class="inputarea custom-select-field"></v-select>
    <v-text-field v-if="selectedImageTypes.includes('Custom Image')" v-model="customImagePrompt" label="Custom Image Prompt" required class="custom-text-field"></v-text-field>
  </v-flex>
  <v-flex xs12 sm12 md6 lg12 xl12>
            <v-checkbox v-model="autoGenerateChapters" label="Auto Generate Chapters"></v-checkbox>
            <button color="primary" class="buttongenerate" @click.prevent="generateConcept">Generate Concept</button>
            <button color="primary" class="buttongenerate" @click.prevent="generateTableOfContents">Generate Table of Contents</button>
            <button color="primary" class="buttongenerate" @click.prevent="generateChapters">Generate Chapters</button>
            <button color="primary" class="buttongenerate" @click.prevent="generateImage">Generate Images</button>
            <button color="primary" class="buttongenerate" @click.prevent="generateChaptersAndImages">Complete Project</button>
            <button color="primary" class="buttongenerate" @click.prevent="exportToTxtMethod">Export to TXT</button>
          </v-flex>
          <v-flex xs4 sm4 md4 lg12 xl12>
            <v-progress-linear :value="timeLeftPercentage"></v-progress-linear>
            <p>{{ statusMessage }}</p>
          </v-flex>
          </v-layout> 
          </v-container>
          </v-form>
          <div v-if="showTimer">
            <v-progress-linear :value="timeLeftPercentage"></v-progress-linear>
            <p>{{ statusMessage }}</p>
          </div>

            <v-textarea v-model="concept" label="Concept" readonly id="book-concept" class="textarea-height"></v-textarea>
            <v-textarea v-model="tableOfContents" label="Table of Contents" readonly id="table-of-contents" class="textarea-height"></v-textarea>
            <!-- <v-textarea v-model="chaptersHtml" label="Chapters" id="chapters text" cols="30" rows="20" class="chapters textarea-height"></v-textarea> -->

            <v-textarea v-model="chaptersHtml" label="Chapters" id="chapters text" cols="30" rows="20" class="chapters textarea-height"></v-textarea>


            <p>Total Words: {{ wordCount }}</p>
            <!-- <v-btn color="primary" @click="readOutLoudText(concept)">Dictate</v-btn> -->
            <v-btn color="primary" @click="readOutLoudText(chaptersHtml)"><i class="fa fa-microphone-alt"></i>
                        <span class="">&nbsp;Dictate</span></v-btn>
            <v-btn color="secondary" @click="togglePause">{{ isPaused ? 'Continue' : 'Pause' }}</v-btn>
            <v-btn color="error" @click="stopReading">Stop</v-btn> 

        
        </v-card-text>
      </v-card>
    </v-container>
    <v-container grid-list-xl>
      <div>
    <input type="file" @change="onFileSelected" />
    <button @click="handleImageUpload">Upload and Generate Variations</button>
    <!-- Image display -->
    <img v-if="generatedImageUrl" :src="generatedImageUrl" alt="Generated Image" />
  </div>
      <v-flex xs12 sm12 md12 lg12>
    <form @submit.prevent="handleImageUpload">
      <v-file-input
        v-model="selectedFile"
        label="Upload an image"
        placeholder="Select an image"
        prepend-icon="mdi-camera"
        outlined
        dense
      ></v-file-input>
      <v-btn
        color="primary"
        class="ma-2"
        :disabled="!selectedFile || loading"
        type="submit"
      >
        Generate Image Variations
      </v-btn>
      <v-btn class="mb-4 download-btn" style="text-decoration: none !important;" :href="generatedImageUrl" target="_blank" download="generated-image">Download</v-btn>
    </form>
    <!-- Display generated image if available -->
    <div v-if="generatedImageUrl" class="image-preview">
      <img style="margin-top: -130px; padding-block: 60px;" :src="generatedImageUrl" alt="Generated Image" />
      <v-btn
        color="secondary"
        @click="downloadImage"
      >
        Download Image
      </v-btn>
    
    </div>
  </v-flex>
          <v-flex xs4 sm4 md4 lg12>

            <div>
    <form @submit.prevent="generateImage">
      <v-text-field 
        v-model="imagePrompt" 
        label="Enter your prompt for the image" 
        required
        clearable
        counter 
        placeholder="Enter your prompt for the image" 
        full-width 
        multi-line
        class="inputarea"
      ></v-text-field>
      <br />
      <v-icon :color="recordingStateColor">mdi-microphone</v-icon>

<v-btn class="btn btn-primary mb-4" @click="promptUserAndStartRecording" v-if="!isRecording">Start</v-btn>
<v-btn class="btn btn-primary mb-4" @click="stopRecording" v-if="isRecording">Listening</v-btn>
      <v-btn class="btn btn-primary mb-4" style="margin-left: 10px;" color="primary" type="submit">Generate Image</v-btn>
    </form>

    <div v-if="generatedImageUrl" class="bookimage-container">
      <v-btn class="mb-4 download-btn" style="text-decoration: none !important;" :href="generatedImageUrl" target="_blank" download="generated-image">Download</v-btn>
      <v-btn class="mb-4 save-btn" @click="saveImage">Save Image</v-btn>
      <v-btn class="mb-4 close-btn" dark @click="generatedImageUrl = false">X</v-btn>
      <h3></h3>
      <img style="margin-top: -130px; padding-block: 60px;" :src="generatedImageUrl" alt="Generated Image" />
    </div>

    <div v-if="loading" class="loading-container">
      <img class="mx-auto d-block" style="height: 25%; width: 25%" src="../assets/images/loading-spinner15.gif" alt="Loading" />
          <br />
        <p>{{ loadingText }}</p>
    </div>
    <br />

        <br />
    <div class="saved-images-container">
      <h3></h3>
      <ul class="image-gallery">
        <li v-for="(savedImage, index) in savedImages" :key="index" @click="openLightbox(savedImage, index)">
          <img :src="savedImage.url" alt="Saved Image" />
          <!-- <div class="overlay"><span>{{ savedImage.prompt }}</span></div> -->
        </li>
      </ul>
      <SavedImageList :saved-items="savedImages" @edit-item="editSavedImage" @delete-item="deleteSavedImage"></SavedImageList>

      <!-- Lightbox Placeholder -->
      <div v-if="isLightboxOpen" class="lightbox">
        <img :src="lightboxImage.url" alt="Lightbox Image" />
        <div>{{ lightboxImage.prompt }}</div>
        <v-btn class="mb-4 download-btn" @click="editSavedImage(lightboxIndex)">Edit</v-btn>
        <v-btn class="mb-4 save-btn" @click="deleteSavedImage(lightboxIndex)">Delete</v-btn>
        <v-btn class="mb-4 close-btn" @click="closeLightbox">Close</v-btn>
      </div>
    </div>
    <div v-if="editedImageUrl" class="edited-bookimage-container">
    <img :src="editedImageUrl" alt="Edited Image" />
    <button @click="downloadEditedImage">Download Edited Image</button>
  </div>
    <div v-if="imageEditorOpen" class="image-editor-container">
    <canvas id="canvas" width="800" height="600"></canvas>
    <button @click="addRectangle">Add Rectangle</button>
    <button @click="addCircle">Add Circle</button>
    <button @click="addText">Add Text</button>
    <button @click="saveEditedImage">Save Image</button>
    <button @click="closeImageEditor">Close Editor</button>
  </div>
  <notifications ref="notifications"></notifications>
  </div>


                  <!-- <BookImageGenerator /> -->
                  <br />
          <br />
          <br />
          </v-flex>
        </v-container>
  </v-content>
</template>

<script>
import { uploadImageAndGenerateVariations } from './imagescript.js';
import { generateConcept, generateTableOfContents, generateChapters, exportToTxt } from './bookscript.js';
// import BookImageGenerator from '../components/BookImageGenerator.vue';
import submitAudio from '../assets/audio/input5.wav';
import codeCompleteAudio from "../assets/audio/completed.wav";
import successAudio from "../assets/audio/input6.wav";
import SavedImageList from './SavedImageList.vue';
import Notifications from './Notification.vue';
import { fabric } from 'fabric';

function delay(ms) {
  return new Promise(resolve => setTimeout(resolve, ms));
}

export default {
  data() {
    return {
      selectedFile: null,
      currentStep: 0,
      bookLength: '',
      gptRole: '',
      genre: '',
      keywords: '',
      autoGenerateChapters: false,
      showImageOverlay: false,
      concept: '',
      tableOfContents: '',
      chaptersHtml: '',
      selectedImageTypes: [],
      imageOptions: ['Cover Art', 'Main Characters', 'Chapters Cover', 'Pivotal Moments', 'Custom Image'],
      customImagePrompt: '',
      showTimer: false,
      timeLeft: 0,
      timeLeftPercentage: 0,
      statusMessage: '',
      imageEditorOpen: false,
      canvas: null,
      imagePrompt: '',
      editedImageURL: null,
      newGeneratedImageUrl: '',
      originalFileName: '',
      generatedImageUrl: null,
      loading: false,
      statusTitle: "Working",
      loadingText: 'Generating Image...',
      wordCount: 0,
      isPaused: false,
      isRecording: false,
      savedImages: JSON.parse(localStorage.getItem("savedImages") || "[]"),
      editingImageIndex: -1,
      downloadImageUrl: null,
      isLightboxOpen: false,
      lightboxImage: null,
      lightboxIndex: null,
      recordingStateColor: 'green', // Default color
      speechSynthesisUtterance: null,
    speechSynthesisPaused: false,
    speechSynthesisIndex: 0, // To track the current position in the text
    availableVoices: [],
    preferredVoices: [
      'Google UK English Male',
      'Google UK English Female',
      'Google US English'
    ],
    voiceOptions: [],
    selectedVoiceName: '',
    selectedVoice: null,
    };
  },
  components: {
    // BookImageGenerator,
    SavedImageList,
  Notifications
  },
  mounted() {
    this.initSpeechSynthesis();
  },
  methods: {
    readOutLoud: (msg) => {
      const speech = new SpeechSynthesisUtterance();
      const voiceName = 'Google UK English Male';
      speech.volume = 1;
      speech.rate = 1;
      speech.pitch = 1;
      speech.voice = speechSynthesis.getVoices().filter(function (voice) {
      return voice.name === voiceName
    })[0]
      speech.text = msg;
      window.speechSynthesis.speak(speech);
    
    },
    onFileSelected(event) {
      // Store the selected file
      this.selectedFile = event.target.files[0];
    },
    async handleImageUpload() {
  if (!this.selectedFile) {
    alert("Please select an image file before submitting.");
    return;
  }
  this.loading = true;
  try {
    const response = await uploadImageAndGenerateVariations(this.selectedFile);
    console.log(response);
    alert("Image variations generated successfully!");
    this.generatedImageUrl = response.imageUrl; // Assuming the URL is in the response
    this.downloadImage(this.selectedFile.name); // Pass the original file name for download
  } catch (error) {
    console.error("Error generating image variations:", error);
    alert("Failed to generate image variations.");
  } finally {
    this.loading = false;
  }
},

downloadImage(originalFileName) {
  const link = document.createElement('a');
  const fileExtension = originalFileName.slice(originalFileName.lastIndexOf('.'));
  const baseFileName = originalFileName.slice(0, originalFileName.lastIndexOf('.'));
  link.href = this.generatedImageUrl;
  link.download = `${baseFileName}_cogai${fileExtension}`; // Set the modified file name
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link); 
},


    scrollToElement(elementId) {
    const element = document.getElementById(elementId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  },
    openImageEditor() {
      this.imageEditorOpen = true;
      this.canvas = new fabric.Canvas('canvas');
      // Further initialization of the canvas...
    },

    addRectangle() {
      const rect = new fabric.Rect({
        left: 100,
        top: 100,
        fill: 'red',
        width: 60,
        height: 70,
        angle: 45
      });
      this.canvas.add(rect);
    },

    addCircle() {
      const circle = new fabric.Circle({
        radius: 20, fill: 'green', left: 100, top: 100
      });
      this.canvas.add(circle);
    },

    addText() {
      const text = new fabric.IText('Hello world', {
        left: 100,
        top: 100,
        fontFamily: 'Arial',
        fill: '#333',
        fontSize: 20
      });
      this.canvas.add(text);
    },

    saveEditedImage() {
      this.editedImageUrl = this.canvas.toDataURL();
      // Additional logic if needed
      this.closeImageEditor();
    },

    downloadEditedImage() {
      // Logic to download the edited image
      const link = document.createElement('a');
      link.href = this.editedImageUrl;
      link.download = 'edited-image.png';
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    },
    closeImageEditor() {
      this.imageEditorOpen = false;
      // Additional cleanup if needed
    },
    togglePause() {
    if (this.isPaused) {
      speechSynthesis.resume();
    } else if (speechSynthesis.speaking) {
      speechSynthesis.pause();
    }
    this.isPaused = !this.isPaused;
  },
    promptUserAndStartRecording() {
      // Use speech synthesis to ask the user what they want to create
      this.readOutLoud('What do you want to create?');
      // Wait for 2 seconds after the question, then start recording
      setTimeout(() => {
      this.isRecording = true;
      this.recordingStateColor = 'green'; // Color when recording starts
      this.startRecording();
    }, 2000);
    },
    promptUserAndStartRecordingGen() {
     
      this.readOutLoud('What is the book length?');
     
      setTimeout(() => {
      this.isRecording = true;
      this.recordingStateColor = 'green'; // Color when recording starts
      this.startRecording();
    }, 2000);
    },
    showNotification(message, type) {
    console.log(`${type}: ${message}`);
    this.$refs.notifications.addNotification(message, type);
  },
  async generateImage() {
    this.showImageOverlay = true;
    setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 4000);
  let imagePrompt;

  if (this.selectedImageTypes.includes('Custom Image') && this.customImagePrompt.trim().length > 0) {

    imagePrompt = this.customImagePrompt.trim();
  } else {
    imagePrompt = this.selectedImageTypes.join(', ');
  }

  if (!imagePrompt) {
    alert("Please enter a prompt for the image or select an image type.");
    this.showNotification("Please enter a prompt for the image or select an image type.", "alert");
    return;
  }

  window.scrollTo({ top: 1400, behavior: 'smooth' });
  this.loading = true;
  new Audio(submitAudio).play();

  let seconds = 0;
  this.readOutLoud(`Generating Image...`);
  this.showNotification("Generating Image....", "alert");
  const interval = setInterval(() => {
    this.loadingText = `Generating Image... (${++seconds}s)`;
  }, 1000);

  try {
    const response = await fetch(`${process.env.VUE_APP_NODE_SERVER}gpt/generate-image`, {
      method: 'POST',
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ message: imagePrompt }),
    });

    if (!response.ok) {
      throw new Error("Failed to generate image");
    }

    const data = await response.json();
    this.generatedImageUrl = data.imageUrl;

    clearInterval(interval);
    this.loadingText = '';
    new Audio(codeCompleteAudio).play();

    const speechSynthesis = window.speechSynthesis;
    const utterance = new SpeechSynthesisUtterance("Your image has been generated.");
    speechSynthesis.speak(utterance);
    this.showNotification("Your image has been generated.", "success");
    this.showImageOverlay = false;
  } catch (error) {
    console.error('Error generating image:', error);
    alert("There was an error generating the image.");
    clearInterval(interval);
    this.loadingText = '';
  } finally {
    this.loading = false;
  }
},

  createDownloadableImage(imageUrl) {
      const canvas = document.createElement('canvas');
    
      this.generatedImageUrl = canvas.toDataURL('image/png');
      
      // For simplicity, let's just set it to the same URL for now
      this.generatedImageUrl = imageUrl;
    },

    startRecording() {
    const SpeechRecognition = window.SpeechRecognition || window.webkitSpeechRecognition;
    const recognition = new SpeechRecognition();
    recognition.lang = 'en-US';
    recognition.start();

    recognition.onstart = () => {
      this.recordingStateColor = 'blue'; // Color when user is speaking
    };

    recognition.onresult = (event) => {
    
      this.imagePrompt = event.results[0][0].transcript;
      this.recordingStateColor = 'red'; // Color just before submitting
      setTimeout(() => {
        this.generateImage();
        this.isRecording = false;
        this.recordingStateColor = 'blue'; // Reset color after submitting
      }, 1000);
    };

    recognition.onerror = (event) => {
      console.error('Speech recognition error', event);
      this.isRecording = false;
    };

    this.isRecording = true;
  },


  stopRecording() {
    this.isRecording = false;
    this.recordingStateColor = 'blue'; // Reset color when stopped
  },

  saveImage() {
  const imageToSave = {
    type: 'image', // Specify the type
    prompt: this.imagePrompt,
    url: this.generatedImageUrl
  };

    if (this.editingImageIndex === -1) {
      this.savedImages.push(imageToSave);
  localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
    } else {
      this.$set(this.savedImages, this.editingImageIndex, imageToSave);
      this.editingImageIndex = -1;
    }

    localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
  },

  updateImage() {
    if (this.editingImageIndex !== -1) {
      const updatedImage = {
        prompt: this.imagePrompt,
        url: this.generatedImageUrl
      };

      this.$set(this.savedImages, this.editingImageIndex, updatedImage);
      this.editingImageIndex = -1;
      localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
    }
  },

  editSavedImage(index) {
    const savedImage = this.savedImages[index];
    this.imagePrompt = savedImage.prompt;
    this.generatedImageUrl = savedImage.url;
    this.editingImageIndex = index;
    // Add any additional logic required for editing the image.
  },

  deleteSavedImage(index) {
    this.savedImages.splice(index, 1);
    localStorage.setItem("savedImages", JSON.stringify(this.savedImages));
  },
  
  openLightbox(image, index) {
      this.lightboxImage = image;
      this.lightboxIndex = index;
      this.isLightboxOpen = true;
    },

    closeLightbox() {
      this.isLightboxOpen = false;
      this.lightboxImage = null;
      this.lightboxIndex = null;
    },
    async activateGenerativeAIProcess() {

  this.readOutLoud("Activating Cognitive A I.");
  this.loadingText = "Preparing AI...";
  this.showImageOverlay = true;
  await delay(5000); // Wait for 3 seconds

  setTimeout(() => {
        this.readOutLoud("AI has been activated on this project.");
        this.loading = false;
      }, 4500);
      setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 2000);
  this.loading = false;
},

scrollToForm() {
 
  this.$nextTick(() => {
    const formElement = this.$refs.form; // Assuming the form has a ref="form"
    if (formElement) {
      formElement.scrollIntoView({ behavior: "smooth" });
    }

    // Hide loading after scrolling
    this.loading = false;
  });
},

activateVoiceFormInput() {
 
  this.promptUserAndStartRecordingGen();
},
async generateConcept() {
  await this.activateGenerativeAIProcess(); // Ensure this completes before proceeding
  this.showImageOverlay = true;
  this.showTimer = true;
  this.startTimer();
  await delay(3000); // Replaced setTimeout with delay for async/await compatibility
  setTimeout(() => {
    this.currentStep = 1;
    this.readOutLoud("Generating Concept...");
    this.showNotification("Generating Concept...", "alert");
  }, 3000);
  new Audio(submitAudio).play();
  const concept = await generateConcept({
    gptRole: this.gptRole,
    bookLength: this.bookLength,
    genre: this.genre,
    keywords: this.keywords.split(',')
  });
  this.concept = concept;
  this.$nextTick(() => {
    this.scrollToElement('book-concept');
  });
  this.automatedGenerationProcess();
  this.readOutLoud("Concept generated successfully");
  this.showNotification("Concept generated successfully.", "alert");
  this.showImageOverlay = false;
  setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 4000);
  new Audio(codeCompleteAudio).play();
},
async generateTableOfContents() {
  this.showImageOverlay = true;
  const contents = await generateTableOfContents({
    gptRole: this.gptRole,
    genre: this.genre,
    keywords: this.keywords.split(','),
    concept: this.concept
  });
  this.tableOfContents = contents;
  this.$nextTick(() => {
    this.scrollToElement('table-of-contents');
  });
  this.readOutLoud("Table of Contents generated successfully");
  this.showNotification("Table of Contents generated successfully.", "alert");
  this.showImageOverlay = false;
  setTimeout(() => {
  window.scrollTo({ top: 0, behavior: 'smooth' });
}, 4000);
  new Audio(codeCompleteAudio).play();
},

 
htmlToPlainText(htmlContent) {
    return htmlContent
      .replace(/<h4>/g, '') // Remove start tag for headings
      .replace(/<\/h4>/g, '\n') // Replace end tag for headings with newline
      .replace(/<p>/g, '') // Remove start paragraph tags
      .replace(/<\/p>/g, '\n\n') // Replace end paragraph tags with double newlines
      .replace(/<br\/>/g, '\n') // Replace break tags with newlines
      .replace(/<br>/g, '\n') // Also replace break tags without self-closing slash
      .trim(); // Trim leading and trailing whitespace
  },
  async generateChapters() {
    this.showImageOverlay = true;
    const chapters = await generateChapters({
      gptRole: this.gptRole,
      genre: this.genre,
      keywords: this.keywords.split(','),
      tableOfContents: this.tableOfContents,
      autoGen: this.autoGenerateChapters
    });

    // Convert HTML chapters to plain text format
    this.chaptersHtml = this.htmlToPlainText(chapters.map(chapter => `<h4>${chapter.title}</h4><p>${chapter.content.replace(/\n/g, '<br/>')}</p>`).join(''));

    this.$forceUpdate();
    this.$nextTick(() => {
      this.scrollToElement('chapters');
    });

    this.readOutLoud("Chapters generated successfully");
    this.showNotification("Chapters generated successfully.", "alert");
    this.wordCount = this.chaptersHtml.split(/\s+/).filter(Boolean).length;
    this.showImageOverlay = false;
    setTimeout(() => {
      window.scrollTo({ top: 0, behavior: 'smooth' });
    }, 6000);
    new Audio(codeCompleteAudio).play();
  },

    exportToTxtMethod() {
      exportToTxt(this.chaptersHtml);
    },
  startTimer(duration) {
    this.timeLeft = duration;
    const timerInterval = setInterval(() => {
      this.timeLeft--;
      this.timeLeftPercentage = (this.timeLeft / duration) * 100;
      if (this.timeLeft <= 0) {
        clearInterval(timerInterval);
        this.showTimer = false;
      }
    }, 1000);
  },

  async generateChaptersAndImages() {
    await this.generateChapters(); // Original chapter generation
  },
  async automatedGenerationProcess() {
    this.loading = true;
    this.statusTitle = "Working";
  try {
    // Start directly with Table of Contents, assuming Concept is already generated
    this.currentStep = 2;
    await this.automatedNextStep(this.generateTableOfContents);
        // After the process completes
        this.statusTitle = "Complete";
        // Optionally, hide the loading animation and title after some time
        setTimeout(() => {
          this.loading = false;
        }, 3000); // Adjust time as needed
      } catch (error) {
    console.error("Error in automated generation process:", error);
    this.loading = false;
  }
},

automatedNextStep(nextFunction) {
  setTimeout(async () => {
    try {
      await nextFunction.call(this); // Use .call(this) to ensure `this` context is preserved
      switch (this.currentStep) {
        case 2:
          // Simulate alert closing automatically
          console.log("Table of Contents generated successfully");
          this.currentStep = 3;
          this.automatedNextStep(this.generateChapters);
          break;
        case 3:
          console.log("Chapters generated successfully");
          this.currentStep = 4;
          this.automatedNextStep(this.generateImage);
          break;
        case 4:
          console.log("Images generated successfully");
          setTimeout(() => {
            this.currentStep = 5; // Indicates the process is complete
          }, 4000);
          this.closeLightbox();
          setTimeout(() => {
            this.saveImage();
            this.generatedImageUrl();
            this.celebrateCompletion();
          }, 5000);
          setTimeout(() => {
            this.readOutLoud("Congratulations, your project is complete!");
            new Audio(successAudio).play();

            this.celebrateCompletion();
          }, 10000);
          // Trigger celebration after last step is complete
        
          break;
      }
    } catch (error) {
      console.error("Error in automated next step:", error);
    }
  }, 3000); // Adjusted to proceed without manual alert closing
},

celebrateCompletion() {
  console.log("Congratulations, your project is complete!");
  this.currentStep = 5; // Indicates the process is complete
  // Placeholder for celebration effect - replace with your own implementation
  this.triggerCelebrationEffect();
},

triggerCelebrationEffect() {
  // This is a placeholder for the confetti or celebration effect.
  // You can integrate a library like canvas-confetti or a custom animation here.
  console.log("Celebration confetti effect goes here.");
  this.confetti.start(); // If using a confetti library
},
initSpeechSynthesis() {
    speechSynthesis.onvoiceschanged = () => {
      this.availableVoices = speechSynthesis.getVoices();
      
      // Filter available voices to match preferred voices and prepare voice options for selection
      this.voiceOptions = this.availableVoices
        .filter(voice => this.preferredVoices.includes(voice.name))
        .map(voice => ({ label: voice.name, value: voice.name }));
      
      // Automatically select the first preferred voice if available
      if (this.voiceOptions.length > 0) {
        this.selectedVoiceName = this.voiceOptions[0].value;
      }
    };
  },
  
  updateSelectedVoice(voiceName) {
    this.selectedVoiceName = voiceName;
    // Update the selected voice for speech synthesis
    const selectedVoice = this.availableVoices.find(voice => voice.name === voiceName);
    if (selectedVoice) {
      this.speechSynthesisUtterance.voice = selectedVoice;
    }
  },
  
readOutLoudText(text) {
    if (this.isPaused) {
      speechSynthesis.resume();
      this.isPaused = false;
      return;
    }
    if (speechSynthesis.speaking || speechSynthesis.paused) {
      speechSynthesis.cancel(); // Stop any ongoing speech
    }
    this.speechSynthesisUtterance = new SpeechSynthesisUtterance(text);
    const voiceName = this.preferredVoices[0] || 'Google UK English';
    this.speechSynthesisUtterance.voice = speechSynthesis.getVoices().find(voice => voice.name === voiceName);
    
    // Configure volume, rate, and pitch as needed
    this.speechSynthesisUtterance.volume = 1; // 0 to 1
    this.speechSynthesisUtterance.rate = 1; // 0.1 to 10
    this.speechSynthesisUtterance.pitch = 1; // 0 to 2

    // Event listener for when the speech finishes
    this.speechSynthesisUtterance.onend = () => {
      console.log('Speech synthesis has finished reading.');
      // Perform any cleanup or UI updates here
    };

    speechSynthesis.speak(this.speechSynthesisUtterance);
  },

  pauseReading() {
    if (speechSynthesis.speaking && !speechSynthesis.paused) {
      speechSynthesis.pause();
      this.isPaused = true;
    } else if (speechSynthesis.paused) {
      speechSynthesis.resume();
      this.isPaused = false;
    }
  },

  stopReading() {
    if (speechSynthesis.speaking || speechSynthesis.paused) {
      speechSynthesis.cancel();
      this.isPaused = false;
    }
  },
  resumeReading() {
    if (speechSynthesis.paused) {
      speechSynthesis.resume();
      this.speechSynthesisPaused = false;
    }
  },
  },
};
</script>

<style scoped>
.image-preview img {
  max-width: 100%;
  height: auto;
}

.image-preview {
  margin-top: 20px;
  text-align: center; /* Centering buttons and image */
  top: -20px;
  left: 0;
  right: 0;
  bottom: 0;
    position: fixed;
  z-index: 9999; /* Ensure it's on top of everything */
  padding-left: 20px;
  padding-right: 20px;
  width: 100%;
  height: 100%;
  background: rgba(12, 22, 27, 0.962);
}
.loading-status {
  position: fixed; /* Fixed position to keep it in view */
  top: -150px; /* Distance from the top */
  right: 100px; /* Distance from the right */
  z-index: 100; /* Ensure it appears above other content */
  background-color: #0c161b53; /* Background color */
  color: #fff;
  font-size: 16px;
  padding: 10px; /* Padding around content */
  border-radius: 5px; /* Rounded corners */
  box-shadow: 0 2px 4px rgba(0,0,0,0.2); /* Shadow for depth */
}

.loading-spinner {
  height: 50px; /* Height of the spinner */
  width: 50px; /* Width of the spinner */
  display: block; /* Ensure it displays correctly */
  margin-bottom: 10px; /* Space between spinner and title */
}
.chapters {
  margin-top: 20px;
  font-size: 16px;
  color: #fff;
}
.overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: #0c161b2f; /* Semi-transparent background */
}

.animated-image {
  /* Initial scale */
  transform: scale(0);
  animation: scaleIn 0.5s forwards, fadeOut 0.5s 30s forwards;
}

@keyframes scaleIn {
  to {
    transform: scale(1);
  }
}

@keyframes fadeOut {
  to {
    opacity: 0;
  }
}
.stepper-flex {
  margin-right: 20px; /* Space between columns */
  max-width: 400px;

}
.steppertitle {
  margin-bottom: 0px;
  margin-left: 20px;
  font-size: 18px;
  color: #fff;
}
/* Futuristic button styles */
.v-stepper .v-stepper-step__step {
  background-color: rgba(15, 8, 32, 0.077); /* Semi-transparent background */
  color: #FFF; /* White text color */
  border: 2px solid rgba(255, 255, 255, 0.75); /* Semi-transparent border */
  transition: all 0.3s ease; /* Smooth transition for hover effects */
}

/* Hover effect */
.v-stepper .v-stepper-step__step:hover {
  background-color: rgba(255, 255, 255, 0.75); /* More opaque on hover */
  transform: scale(1.05); /* Slightly larger */
  cursor: pointer; /* Change cursor to indicate it's clickable */
}

/* Step content styling */
.v-stepper-content {
  color: #FFF; /* White text color for content */
}
.book-generator {
  max-width: 100%;
  margin: 20px auto;
  padding: 20px;
  color: #fff;
  /* outline: 3px solid #000000; */
  border-radius: 23px;
  background: #db000700;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    }
    .book-generator2 {
  max-width: 100%;
  margin: 0 auto;
  padding: 20px;
  color: #fff;
  background: #203642e1;
    -webkit-animation: gradient 25s ease infinite;
    -animation: gradient 25s ease infinite;
  }
    @-webkit-keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
    }
  
    @keyframes gradient {
      0% {
        background-position: 0% 50%;
      }
      50% {
        background-position: 100% 50%;
      }
      100% {
        background-position: 0% 50%;
      }
      height: 100%;
    }
.book-generator h1 {
  text-align: center;
}
.chapters {
  margin-top: 20px;
  font-size: 16px;
  color: #fff;
}

/* textarea {
  margin-bottom: 20px;
  font-size: 16px;
  color: #fff;
}
.field {
  margin-bottom: 30px;
  padding: 30px;
  border-radius: 20px;

}

.field label {
  display: block;
  font-size: 16px;
  color: rgb(255, 255, 255);
}

.field input {
  display: block;
  min-width: 500px;
  line-height: 2.5;
  font-size: 16px;
  color: rgb(36, 212, 65);
  border-radius: 20px;
  padding-block: 20px;
  margin-block: 5px;
  border: 1px solid transparent;
}

input[type="submit"] {
  display: block;
  padding: 10px 40px;
  font-size: 14px;
  background-color: #4460AA;
  color: #fff;
  border: none;
  background: rgba(48, 64, 87, 0.8);
  outline-color: #42da91;
  color: #fff;
  border: 1px solid transparent;
  height: 50px;
} */
.buttongenerate  {
  background-color: rgba(255, 255, 255, 0.1); /* Transparent White */
   border: 1px solid rgba(255, 255, 255, 0.3); /* Slightly visible white */
   color: #FFF; /* White Text */
   border-radius: 15px;
   transition: all 0.5s ease-in-out;
   height: 50px;
   width: 265px;
   padding-block: 10px;
   margin-block: 10px;
   margin-right: 10px;
}
.buttongenerate:hover {
  background-color: rgba(255, 255, 255, 0.3); /* More visible white */
  border: 1px solid rgba(255, 255, 255, 0.5); /* More visible white */
  color: #FFF; /* White Text */
  transform: scale(1.05); /* Slightly larger on hover */
  cursor: pointer; /* Change cursor to indicate it's clickable */
}

</style>

<style scoped>

@keyframes pulse {
  0% { transform: scale(1); }
  50% { transform: scale(1.2); }
  100% { transform: scale(1); }
}

.mdi-microphone {
  top: -7px;
  animation: pulse 1s infinite;
}
.bookimage-container img {
  max-width: 100%;
  height: auto;
}

.bookimage-container {
  margin-top: 20px;
  text-align: center; /* Centering buttons and image */
  top: -20px;
  left: 0;
  right: 0;
  bottom: 0;
    position: fixed;
  z-index: 9999; /* Ensure it's on top of everything */
  padding-left: 10px;
  padding-right: 10px;
  max-width: 100%;
  height: 100%;
  background: rgba(12, 22, 27, 0.962);
}

.saved-images-container {
    padding: 15px 15px 15px 15px;
    border: 1px solid #1d323b;
    border-radius: 5px;
    margin-top: -30px;
    margin-bottom: 10px;
    max-height: fit-content;
    background: #1d323bc7;
    overflow-y: auto;
    font-size: 19px;
    font-family: 'Nunito Sans', sans-serif;
    box-shadow: rgba(187, 187, 197, 0.05) 0px 20px 40px -12px inset, rgba(236, 235, 235, 0.10) 0px 12px 22px -6px inset;
}

.image-gallery {
  column-count: 3; /* Adjust based on your preference */
  column-gap: 20px;
  margin-left: -10px;
  margin-right: 10px;
  text-decoration: none !important;
}

.image-gallery > li {
  break-inside: avoid;
  margin-bottom: 10px;
  cursor: pointer;
  text-decoration: none !important;
  list-style: none;
}

/* Lightbox styles */
.lightbox {
  position: fixed;
  width: 60%;
  height: 60%;
  top: 44%;
  left: 50%;
  color: #fff;
  transform: translate(-50%, -50%);
  background: linear-gradient(90deg, #0c161bd5, #0c161b8b);
  z-index: 1000; /* Make sure it's above other content */
  border-radius: 10px;
  text-align: center;
}

.image-gallery li img {
  object-fit: cover;
  width: 100%;
  height: 100%;
  vertical-align: middle;
  border-radius: 5px;
}

.image-gallery li .v-btn {
  opacity: 0.8;
  outline: 1px solid #fff; /* White outline */
  margin: 10px;
  background-color: rgba(0, 0, 139, 0.6); /* Transparent dark blue */
  color: white; /* Text color */
  border: none; /* Remove default border if any */
  border-radius: 4px; /* Optional: for rounded corners */
}

.image-gallery li .v-btn:hover {
  opacity: 1; /* Full opacity on hover */
}

.download-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: -10px;
  opacity: 0.8;
}
.save-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 0px;
  opacity: 0.8;
}
.close-btn {
  position: top-right;
  width: 100px;
  height: 100px;
  color: #fff;
  background: linear-gradient(90deg, #0c161b, #0c161b);
  top: 50px;
  left: 10px;
  opacity: 0.8;
}
.overlay {
  background: rgba(0, 0, 0, 0.5);
  border: #000;
  border-radius: 10px;
  color: white;
  width: 100%;
  text-align: center;
  padding: 10px 10px;
}
.inputarea {
  width: 100%;
  padding: 20px;
  margin-block: 5px;
  border: 1px solid #ccc;
  border-radius: 4px;
  box-sizing: border-box;
  resize: vertical;
  --glow: drop-shadow(0 0 1px violet);
  filter: var(--glow) brightness(1) drop-shadow(0 0 5px violet);
  font-family: 'Lucida Sans', 'Lucida Sans Regular', 'Lucida Grande', 'Lucida Sans Unicode', Geneva, Verdana, sans-serif;
  font-size: 1.2rem;
  color: #000;
}
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 5px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
  color: #fff;
  text-align: center;
  font-size: 1.3rem;
  font-weight: normal;
  font-family: 'Roboto', sans-serif;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
@media only screen and (max-width: 900px) {
.loading-container {
  background: rgba(12, 22, 27, 0.4);
  border-color: #5a80bf;
  color: #efe;
  outline-width: 2px;
  padding: 25px;
  border-radius: 10px;
  margin: 10px;
  top: 160px;
}
@keyframes glow2 {
  0% {
    border-color: #00adb4;
    box-shadow: 0 0 5px rgba(0, 255, 0, 0.2), inset 0 0 5px rgba(120, 166, 156, 0.1), 0 2px 0 #000;
  }

  100% {
    border-color: #78cce2;
    box-shadow: 0 0 8px rgba(90, 128, 191, 0.8), inset 0 0 10px rgba(120, 166, 156, 0.4), 0 2px 0 #000;
  }
}
}
</style>